export const createPlaceholderNode = (entityType, name, isLoadingData) => ({
  id: 'invalid',
  isPlaceholderNode: true,
  name,
  entityType,
  state: { expanded: false },
  isLoadingData,
});
